import { Component, Input } from '@angular/core';
import { BaseChangesTable } from '../base-table-changes';
import { overlayTypologyType } from '../../../../../../shared/enums';

@Component({
    standalone: false,
    selector: 'overlay-typology-changes-table',
    templateUrl: './overlay-typology-changes-table.component.html',
    styleUrls: ['../base-changes-style.scss']

})
export class OverlayTypologyChangesTableComponent extends BaseChangesTable {
    @Input()
    overlayTypologyLabels: any;

    overlayTypologyRow = ['Label', 'Type', 'Status'];

    getTypeNameById(id) {
        return overlayTypologyType[id];
    }
}
